export const monotonicNow = () => performance.now()
export const visible = () => typeof document === 'undefined' || document.visibilityState !== 'hidden'
export const browserOnline = () => typeof navigator === 'undefined' || navigator.onLine !== false

export class WebSocketLifecycle {
    constructor(service) {
        this.service = service
        this.removers = []
        this.suspended = false
    }
    attach() {
        if (this.removers.length || typeof window === 'undefined') return
        const on = (target, event, callback) => {
            target.addEventListener(event, callback)
            this.removers.push(() => target.removeEventListener(event, callback))
        }
        on(document, 'visibilitychange', () => { if (visible()) this.service.resume('visible') })
        for (const event of ['pagehide', 'freeze']) {
            on(event === 'freeze' ? document : window, event, () => {
                this.suspended = true
                this.service.pause('page_suspended')
            })
        }
        for (const event of ['pageshow', 'resume']) {
            on(event === 'resume' ? document : window, event, () => {
                this.suspended = false
                this.service.resume(event)
            })
        }
        on(window, 'offline', () => this.service.pause('browser_offline'))
        on(window, 'online', () => this.service.resume('online'))
    }
    available() { return !this.suspended && browserOnline() }
    detach() {
        this.removers.splice(0).forEach(remove => remove())
        this.suspended = false
    }
}
